import { render, staticRenderFns } from "./AdminSettingChangeProfileName.vue?vue&type=template&id=4ebfd6a6&scoped=true&"
import script from "./AdminSettingChangeProfileName.vue?vue&type=script&lang=js&"
export * from "./AdminSettingChangeProfileName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebfd6a6",
  null
  
)

export default component.exports